import flattenDeepArray from 'lodash/flattenDeep'
import moment from 'moment'
import formatAddress from './formatAddress'
import extractSinglePhoneNumber from './extractSinglePhoneNumber'
export { default as toast } from './toast'

const getTenantsFromBuilding = (buildingObj) =>
  flattenDeepArray(
    buildingObj.apartments.map((apartment) =>
      apartment.leases.map((lease) =>
        lease.tenants.map((tenant) => tenant),
      ),
    ),
  )

const getTenantsFromApartment = (apartment) =>
  flattenDeepArray(
    apartment.leases.map((lease) =>
      lease.tenants.map((tenant) => tenant),
    ),
  )

const getInPlaceLeaseFromApartment = (apartment) =>
  apartment.leases.find(
    ({ leaseStartDate, leaseEndDate }) =>
      moment(leaseStartDate).isBefore(moment()) &&
      moment(leaseEndDate).isAfter(moment()),
  )

const getExpireLeaseFromApartment = (apartment) =>
  apartment.leases.filter(({ leaseEndDate }) =>
    moment(leaseEndDate).isBefore(moment()),
  )

const getFutureLeaseFromApartment = (apartment) =>
  apartment.leases.filter(({ leaseStartDate }) =>
    moment(leaseStartDate).isAfter(moment()),
  )

const getInPlaceTenantsFromApartment = (apartment) => {
  const inPlaceLease = getInPlaceLeaseFromApartment(apartment)
  if (inPlaceLease) {
    return inPlaceLease.tenants
  }
  return []
}

const getInPlaceTenantsFromBuilding = (buildingObj) =>
  flattenDeepArray(
    buildingObj.apartments.map((apartment) =>
      getInPlaceTenantsFromApartment(apartment),
    ),
  )

const isThisLeaseInPlace = ({ leaseStartDate, leaseEndDate }) =>
  moment(leaseStartDate).isBefore(moment()) &&
  moment(leaseEndDate).isAfter(moment())

const getVacantApartments = (apartmentArray) =>
  apartmentArray.filter(
    (apartment) => !getInPlaceLeaseFromApartment(apartment),
  )

let validateName = (name) => /^[a-z ,.'-]+$/i.test(name)

export {
  validateName,
  formatAddress,
  extractSinglePhoneNumber,
  getTenantsFromBuilding,
  getTenantsFromApartment,
  getInPlaceLeaseFromApartment,
  getExpireLeaseFromApartment,
  getInPlaceTenantsFromApartment,
  isThisLeaseInPlace,
  getVacantApartments,
  getInPlaceTenantsFromBuilding,
  getFutureLeaseFromApartment,
}
